<template>
  <div id="myContacts text-dark-grey">
    <div class="dashboard-headline py-3">
      <div class="row justify-content-left">
        <div class="text-right px-2">
          <Btn
            @click.native="onAddContact"
            :icon="['fal', 'plus-circle']"
            :label="$t('contacts.addNewContact')"
          />
        </div>
        <div class="d-md-inline text-right px-2">
          <Btn
            @click.native="deleteAll"
            :icon="['fal', 'trash-alt']"
            :label="$t('contacts.deleteAllContacts')"
          />
        </div>
      </div>
    </div>

    <div class="upload-contact contact-list-wrapper mb-2 mt-2">
       <div class="direction-column">
        <div class="row">
          <div class="col-12 text-left">
            {{ $t('contacts.uploadNote2') }}
          </div>
        </div>
        <div class="row">
          <div class="col-12 text-left">
            {{ $t('contacts.uploadNote3') }}
          </div>
        </div>
        <div class="row">
          <div class="col-12 text-left">
            {{ $t('contacts.uploadNote4') }}
          </div>
        </div>
        <div class="row">
          <div class="col-12 text-left">
            <form
              enctype="multipart/form-data"
              novalidate
            >
              <div class="dropbox">
                <input
                  type="file"
                  :name="uploadFieldName"
                  ref="fileupload"
                  :disabled="isProcessingFile"
                  @change="filesChange($event.target.name, $event.target.files)"
                  accept="application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/msexcel, text/comma-separated-values"
                  class="input-file"
                />
                <p v-if="!selectedFileName">
                  {{ $t('contacts.dropboxNotice1') }}<br />
                  {{ $t('contacts.dropboxNotice2') }}<br />
                </p>
                <p v-else> {{ selectedFileName }} </p>
                <p v-if="isProcessingFile && !currentUploadStatus">{{ this.$t('contacts.uploading') }}</p>
                <p v-else>{{ currentUploadStatus }}</p>
              </div>
            </form>
          </div>
        </div>
        <!-- <div class="row mt-1">
          <div class="col-12">
            <button class="btn btn-primary btn-sm" @click="cancelUpload">
              <font-awesome-icon
                class="text-white mx-2"
                :icon="['fal', 'times']"
              />
              {{ $t('contacts.cancel') }}
            </button>
          </div>
        </div> -->
      </div>
    </div>

    <div class="search-filed">
      <div class="form-group text-dark-grey text-size-16">
        <input
          :placeholder="$t('contacts.searchPlaceholder')"
          v-model="searchText"
          class="form-control search-field"
          type="text"
        />
      </div>
    </div>

    <!---  End of Nav Header -->
    <div class="contact-list-wrapper mb-2 mt-2">
      <div v-if="1" class="row px-2">
        <!-- Contacts List -->
        <ContactsList
          @update="onUpdate"
          :searchText="searchText"
          :contacts="contacts"
        />
      </div>
    </div>
    <ContactDialog
      @save="onSave"
      :contact="selectedContact"
      :loading="addingContact"
      ref="dlContactDialog"
    />
    <ModalConfirm
      v-show="confirmDeleteAll"
      :msg="$t('contacts.confirmDeleteContacts')"
      @confirm="deleteAllConfirmed"
      :loading="deletingAll"
      @cancel="confirmDeleteAll = false"
    />
    <ModalConfirm
      v-show="contactToBoRemoved"
      :msg="confirmMessageDeleteContact"
      :loading="removingContact"
      @confirm="deleteContactConfirmed"
      @cancel="contactToBoRemoved = null"
    />
  </div>
</template>

<script>
import { HTTP } from '@/shared/http';
import shared from '@/shared.js';
import ContactsList from '@/components/Contacts/ContactsList';
import ContactDialog from '@/components/Contacts/ContactDialog';

export default {
  data() {
    return {
      contacts: [],
      searchText: '',

      selectedContact: { id: null, name: null, email: null },
      addContactObj: { name: null, email: null },
      addingContact: false,
      isUploadMode: false,
      uploadedFiles: [],
      uploadError: null,
      currentUploadStatus: null,
      uploadFieldName: 'contacts',
      selectedFileName: null,
      isProcessingFile: false,
      confirmDeleteAll: false,
      deletingAll: false,

      contactToBoRemoved: null,
      removingContact: false,
      msg: null,
    };
  },

  components: {
    ContactsList,
    ContactDialog,
  },

  methods: {
    onAddContact() {
      console.log('add new contact');
      this.selectedContact = { id: null, name: null, email: null };
      this.$refs.dlContactDialog.openModal();
    },

    addContact(contact) {
      const apiUrl = process.env.VUE_APP_API_URI_SEGMENT;
      const url = apiUrl + '/contact';
      console.log('addContact with the following Url:' + url);

      this.addingContact = true;
      HTTP.post(url, contact)
        .then((response) => {
          console.log('Processing the loaded contacts:', response);
          this.contacts = response.data;
          localStorage.setItem('contacts', JSON.stringify(this.contacts));
          this.$refs.dlContactDialog.closeModal();
          this.addingContact = false;
        })
        .catch((error) => {
          console.log(error.response.datacontactEmailAllreadyExists);
          this.addingContact = false;
          this.$refs.dlContactDialog.errors.email = this.$t('contacts.wrnEmailExists');
        }
        
        );
    },

    onSave(contact) {
      console.log('OnSave:', contact);
      if (contact.id) {
        console.log('Update contact');
        this.saveContact(contact);
      } else {
        console.log('Add new  contact');
        this.addContact(contact);
      }
      
    },

    showConfirmDeleteContact(contact) {
      console.log('Remove contact:', contact);
      this.removingContact = false;
      this.contactToBoRemoved = contact;
    },

    onUpdate(change) {
      console.log('OnUpdate:', change);
      if (change.cmd === 'edit') {
        this.editContact(change.contact);
        return;
      }
      if (change.cmd === 'delete') {
        this.showConfirmDeleteContact(change.contact);
        return;
      }
    },

    getImageUrl(id) {
      return '@/userImages/' + id + '.png';
    },
    editContact(contact) {
      this.selectedContact = contact;
      this.$refs.dlContactDialog.openModal();
    },
    closeEdit() {
      console.log("closeEdit");
      this.editContactObj.id = null;
      this.editContactObj.name = null;
      this.editContactObj.email = null;

    },
    cancelAdd(quitAdd) {
      this.addContactObj.name = null;
      this.addContactObj.email = null;
      this.isAddMode = !quitAdd;
    },
    saveContact() {
      const apiUrl = process.env.VUE_APP_API_URI_SEGMENT;
      const url = apiUrl + '/contact/' + this.selectedContact.id;
      console.log('SaveContact with the following Url:' + url);
      this.addingContact = true;
      HTTP.put(url, this.selectedContact)
        .then((response) => {
          console.log('Processing the loaded contacts:', response);
          this.contacts = response.data;
          localStorage.setItem('contacts', JSON.stringify(this.contacts));
          this.addingContact = false;
          this.$refs.dlContactDialog.closeModal();       
        })
        .catch((error) => console.log(error));
    },

    deleteContact(id) {
      const apiUrl = process.env.VUE_APP_API_URI_SEGMENT;
      const url = apiUrl + '/contact/' + id;
      console.log('deleteContact with the following Url:' + url);

      HTTP.delete(url)
        .then((response) => {
          console.log('Delete response:', response);
          let deletedIndex = this.contacts.findIndex((item) => item.id === id);
          if (deletedIndex > -1) {
            this.contacts.splice(deletedIndex, 1);
            localStorage.setItem('contacts', JSON.stringify(this.contacts));
          }
          this.contactToBoRemoved = null;
        })
        .catch((error) => console.log(error));
    },

    deleteContactConfirmed() {
      console.log(
        'Delete contact was confirmed:',
        this.contactToBoRemoved.name
      );
      this.deleteContact(this.contactToBoRemoved.id);
      this.removingContact = true;
    },

    uploadFile() {
      this.reset();
      this.isUploadMode = true;
    },

    deleteAllConfirmed() {
      const apiUrl = process.env.VUE_APP_API_URI_SEGMENT;
      const url = apiUrl + '/contacts';
      console.log('deleteContacts with the following Url:' + url);
      const checkCount = this.contacts.length;
      this.deletingAll = true;
      HTTP.delete(url)
        .then((response) => {
          console.log('Delete response:', response);
          if (response.status === 200) {
            let deleteCount = response.data.deleteCount;
            if (deleteCount && deleteCount > 0 && deleteCount === checkCount) {
              this.contacts = [];
              localStorage.setItem('contacts', JSON.stringify(this.contacts));
            }
            this.confirmDeleteAll = false;            
            this.deletingAll = false;
          } else {
            console.log(
              'Error deleting contracts. Status: ',
              response.status,
              ' Message:',
              response.data.message,
              ', DeleteCount:',
              response.data.deleteCount
            );
          }

          //dialog.close();
        })
        .catch((error) => { 
          this.confirmDeleteAll = false;            
          this.deletingAll = false;
          alert(this.$t(error.response.data.error));
        });
    },

    deleteAll() {
      this.msg = this.$t('contacts.confirmDeleteContacts');
      this.confirmDeleteAll = true;
    },

    reset() {
      // reset form to initial state
      this.currentUploadStatus = null;
      this.uploadedFiles = [];
      this.uploadError = null;
      this.isProcessingFile = false;
      this.$refs.fileupload.value=null;
      this.selectedFileName = null;
    },

    saveUpload(formData) {
      this.isProcessingFile = true;
      const apiUrl = process.env.VUE_APP_API_URI_SEGMENT;
      const url = apiUrl + '/contacts/upload';

      HTTP.post(url, formData)
        .then((response) => {
          if(response.data.response.success == true) {
            this.contacts = response.data.contacts;
          } 
          this.currentUploadStatus = response.data.response.message;
          window.setTimeout(() => {
            this.reset();
          }, 1000);
        })
        .catch((err) => {
          this.uploadError = err.response;
          this.reset();
        });
    },
    filesChange(fieldName, fileList) {
      // handle file changes
      const formData = new FormData();
      if (!fileList.length) return;
      // append the files to FormData
      Array.from(Array(fileList.length).keys()).map((x) => {
        formData.append(fieldName, fileList[x], fileList[x].name);
        this.selectedFileName = fileList[x].name;
      });
      // save it
      this.saveUpload(formData);
    },
    getContacts() {
      const apiUrl = process.env.VUE_APP_API_URI_SEGMENT;
      const url = apiUrl + '/contacts';
      console.log('Using the followingUrl:' + url);
      HTTP.get(url)
        .then((response) => {
          console.log('Processing the loaded contacts:', response);
          this.contacts = response.data;
          localStorage.setItem('contacts', JSON.stringify(this.contacts));
        })
        .catch((error) => console.log(error));
    },
  },
  computed: {
    saveColor() {
      return this.editContactObj.name && this.editContactObj.email
        ? 'green'
        : 'red';
    },

    confirmMessageDeleteContact() {
      if (!this.contactToBoRemoved) {
        return 'No contact selected!!';
      }
      let msg = this.$t('contacts.confirmDeleteContact');
      return msg.replace('%s', this.contactToBoRemoved.name);
    },
  },

  mounted() {
    this.lastUpdate = shared.lastUpdate;
    this.reset();
    const apiUrl = process.env.VUE_APP_API_URI_SEGMENT;
    const url = apiUrl + '/contacts';
    console.log('Using the followingUrl:' + url);

    const contactsLoaded = localStorage.getItem('contacts');
    if (contactsLoaded) {
      console.log('read contacts from local storage');
      this.contacts = JSON.parse(contactsLoaded);
    }

    HTTP.get(url)
      .then((response) => {
        console.log('Processing the loaded contacts:', response);
        this.contacts = response.data;
        localStorage.setItem('contacts', JSON.stringify(this.contacts));
      })
      .catch((error) => console.log(error));

    console.log('mount completed');
  },
};
</script>

<style lang="scss" scoped>
@import '@/styles/style.scss';

.dashboard-headline {
  display: flex;
  flex-direction: column;
  max-width: 800px;
}

.search-filed {
  max-width: 800px;
  // justify-content: end;
  display: flex;
}

.contact-list-wrapper {
  max-width: 800px;
}

.direction-column {
  flex-direction: column;
  font-size: $very-small;
}

.dropbox {
  outline: 2px dashed grey;
  outline-offset: -10px;
  background: #cccccc;
  color: black;
  padding: 10px 10px;
  min-height: 200px;
  position: relative;
  cursor: pointer;
}

.input-file {
  opacity: 0;
  width: 100%;
  height: 200px;
  position: absolute;
  cursor: pointer;
  top: 0;
  left: 0;
}

.dropbox:hover {
  background: #aaaaaa;
}

.dropbox p {
  font-size: 1.2em;
  text-align: center;
  padding: 20px 0;
}

.form-control.search-field {
  font-size: 16px;
  color: $dark-grey;
}
</style>
